{
  "languages": {
    "arabic": "Arabisch",
    "belarusian": "Wit-Russisch",
    "chinese": "Chinees",
    "dutch": "Nederlands",
    "english": "Engels",
    "french": "Frans",
    "german": "Duits",
    "italian": "Italiaans",
    "japanese": "Japans",
    "korean": "Koreaans",
    "lithuanian": "Litouws",
    "portuguese": "Portugees",
    "romanian": "Roemeens",
    "spanish": "Spaans",
    "turkish": "Turks"
  }
}
